// @flow
import React from 'react';
import { MdArrowBack, MdClose, MdMoreVert } from 'react-icons/md';
import cx from 'classnames';
import { FaRegImage } from 'react-icons/fa';
import './WriteHeader.scss';

type Props = {
  onChangeTitle(e: any): void,
  onUploadClick(): void,
  onOpenSubmitBox(): void,
  onCloseSubmitBox(): void,
  onShowWriteExtra(): void,
  onHideWriteExtra(e: SyntheticMouseEvent<any>): void,
  onGoBack(): void,
  writeExtraOpen: boolean,
  title: string,
  isEdit: boolean,
  isOpen: boolean,
};
const WriteHeader = ({
  onChangeTitle,
  onOpenSubmitBox,
  onCloseSubmitBox,
  onUploadClick,
  onShowWriteExtra,
  onHideWriteExtra,
  onGoBack,
  writeExtraOpen,
  title,
  isEdit,
  isOpen,
}: Props) => {
  return (
    <div className="WriteHeader">
      <MdArrowBack className="back-icon" onClick={onGoBack} />
      <div className="title-area">
        <input
          placeholder="타이틀을 입력해주세요."
          autoFocus
          onChange={onChangeTitle}
          value={title}
        />
      </div>
      <div className="actions">
        {/* <button className="upload-image" onClick={onUploadClick}>
          <FaRegImage />
          <div className="btn-text">업로드</div>
        </button> */}
        <div className={cx('wh-button', isEdit ? 'edit' : 'submit')} onClick={onOpenSubmitBox}>
          {isEdit ? '업데이트' : '등록하기'}
        </div>
        {writeExtraOpen && (
          <div className="ignore-click-outside more util flex-center" onClick={onHideWriteExtra}>
            <MdClose className="ignore-click-outside" />
          </div>
        )}
        {!writeExtraOpen && (
          <div className="ignore-click-outside more util flex-center" onClick={onShowWriteExtra}>
            <MdMoreVert className="ignore-click-outside" />
          </div>
        )}
      </div>
    </div>
  );
};

export default WriteHeader;



// WEBPACK FOOTER //
// ./src/components/write/WriteHeader/WriteHeader.js